// Recovered compiled webpack factory 72103. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ServerInsertedHTMLContext: function () {
        return a;
      },
      useServerInsertedHTML: function () {
        return o;
      },
    }));
  let n = r(49417)._(r(12115)),
    a = n.default.createContext(null);
  function o(e) {
    let t = (0, n.useContext)(a);
    t && t(e);
  }
}
